const DURATIONS = {
    FIVE_MINUTES: 5 * 60 * 1000,
    ONE_DAY: 24 * 60 * 60 * 1000,
    ONE_HOUR: 60 * 60 * 1000,
    ONE_MINUTE: 60 * 1000,
    ONE_WEEK: 7 * 24 * 60 * 60 * 1000,
    TEN_MINUTES: 10 * 60 * 1000,
    THIRTY_DAYS: 30 * 24 * 60 * 60 * 1000,
    TWENTY_EIGHT_DAYS: 28 * 24 * 60 * 60 * 1000,
} as const;

export default DURATIONS;
